<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Stock Transfer Receipts</h4>
                <p class="text-subtitle-1">List of stock transfe Receipts</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field
                    label="Search"
                    v-model="search.code"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    rounded
                    dense
                    hide-details
                    @input="handleSearchByCode"
                    ></v-text-field>  
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="data"
                    disable-sort
                    :page.sync="page"
                    :options.sync="options"
                    :loading="loading"
                    :server-items-length="serverItemsLength"
                    >
                    <template v-slot:[`item.date`]="{item}">
                        {{formatDate(item.date)}}
                    </template>
                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="handleDisplay(item)" v-if="isReadable">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                    <template v-slot:[`item.state`]="{item}">
                        <PStatus :state="item.state"/>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import stockTransferReceiptAPI from '../../../services/stockJournal/stockTransferReceipt';
import PStatus from './../../../components/common/PStatus.vue'
import moment from 'moment';
import authorize from '../../../utils/authorize';
import permissions from '../../../data/permissions';

export default {
    components: {
        PStatus
    },
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Source Warehouse", value: "source_warehouse" },
                // { text: "Destination", value: "destination" },
                { text: "Created By", value: "created_by" },
                { text: "State", value: "state" }
            ],
            data: [],
            options: {},
            search: {},
            page: 1,
            serverItemsLength: 0,
            loading: false,
            warehouseId: null,
            permissions
        }
    },
    computed: {
        isReadable() {
            return this.hasPermission(this.permissions.stock_transfer_receipt.read)
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetch();
            }
        },
    },
    methods: {
        hasPermission(code) {
            return authorize(code)
        },
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        handleNew() {
            this.$router.push({
                name: "TransferIssueVoucherCreate"
            })
        },
        fetch() {
            this.loading = true;
            this.data = [];
            stockTransferReceiptAPI.index({...this.options, ...this.search, target_warehouse_id: this.warehouseId}).then(response => {
                this.data = response.data.data;
                this.serverItemsLength = response.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleDisplay(item) {
            this.$router.push({
                name: "TransferReceiptVoucherDisplay",
                params: {
                    id: item.id
                }
            })
        },
        handleSearchByCode() {
            this.fetch();
        }
    },
    created() {
        this.warehouseId = this.$route.params.warehouseId
    }
}
</script>

<style>

</style>